/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';

export interface GetFineDiscrepancy$Heif$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  discrepancyKey: KeyType;
}

export function getFineDiscrepancy$Heif(http: HttpClient, rootUrl: string, params: GetFineDiscrepancy$Heif$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, getFineDiscrepancy$Heif.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('discrepancyKey', params.discrepancyKey, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/heif', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

getFineDiscrepancy$Heif.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/fine-discrepancies/{discrepancyKey}';
